module.exports = __webpack_public_path__ + "img/document.fe469055.png";